import { useState, useCallback } from 'react';
import { haptic } from '../utils/haptic';

const tg = window.Telegram?.WebApp;

export function useEmojiStatus() {
  const [status, setStatus] = useState<'idle' | 'requesting' | 'granted' | 'denied'>('idle');

  const isAvailable = Boolean(
    tg?.requestEmojiStatusAccess && tg?.setEmojiStatus,
  );

  const requestAndSet = useCallback(
    (customEmojiId: string, durationSeconds = 3600) => {
      if (!tg?.requestEmojiStatusAccess || !tg?.setEmojiStatus) return;

      setStatus('requesting');

      tg.requestEmojiStatusAccess((granted: boolean) => {
        if (!granted) {
          setStatus('denied');
          haptic.error();
          return;
        }

        setStatus('granted');

        tg.setEmojiStatus!(
          customEmojiId,
          { duration: durationSeconds },
          (success: boolean) => {
            if (success) {
              haptic.success();
            } else {
              haptic.error();
            }
          },
        );
      });
    },
    [],
  );

  return { isAvailable, status, requestAndSet };
}
